import api, { formatApiErrorDetail } from "@/lib/api";
import { useLocation } from "react-router-dom";
import { useEstablishments } from "@/context/EstablishmentContext";
import { Messaging } from "@/components/messaging/Messaging";

const E = (e) => formatApiErrorDetail(e.response?.data?.detail) || "Erreur";

export default function Messages() {
  const { current } = useEstablishments();
  const { search } = useLocation();
  if (!current) return null;
  const sp = new URLSearchParams(search);
  const c = sp.get("c"); const f = sp.get("filter") || "";
  return <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto space-y-5" data-testid="messages-page">
    <div><h1 className="font-heading text-2xl sm:text-3xl font-bold">Messages</h1><p className="text-sm text-slate-500">Canal professionnel avec votre équipe : qui a lu, qui a pris connaissance, qui s'en occupe, ce qui est fait — avec pièces jointes sécurisées et traçabilité.</p></div>
    <Messaging key={`${current.id}${search}`} http={api} E={E} base={`/staffing/${current.id}/msg`} mode="employer" initialConv={c} initialFilter={f} />
  </div>;
}
